import { app } from "@eg_ui/src/app/client";
import { defineAsyncComponent } from "vue";

import "@eg_ui/src/scss/client/authentication.scss";

app.component(
    "LoginForm",
    defineAsyncComponent(() => import("@eg_ui/src/components/authentication/LoginForm/LoginForm.vue")),
)
    .component(
        "TextField",
        defineAsyncComponent(() => import("@eg_ui/src/components/formFields/TextField/TextField.vue")),
    )
    .component(
        "SelectField",
        defineAsyncComponent(() => import("@eg_ui/src/components/formFields/SelectField/SelectField.vue")),
    )
    .component(
        "confirm-form",
        defineAsyncComponent(() => import("@eg_ui/src/components/authentication/_account/ConfirmForm/ConfirmForm.vue")),
    )
    .component(
        "ErrorExplainer",
        defineAsyncComponent(() => import("@eg_ui/src/components/globals/ErrorExplainer/ErrorExplainer.vue")),
    )
    .component(
        "html5-validation-restyler",
        defineAsyncComponent(
            () => import("@eg_ui/src/components/globals/Html5ValidationRestyler/Html5ValidationRestyler.vue"),
        ),
    )
    .component(
        "TimezoneDetect",
        defineAsyncComponent(() => import("@eg_ui/src/components/globals/TimezoneDetect/TimezoneDetect.vue")),
    )
    .component(
        "ConnectionSelector",
        defineAsyncComponent(
            () => import("@eg_ui/src/components/authentication/ConnectionSelector/ConnectionSelector.vue"),
        ),
    )
    .component(
        "view-password-field",
        defineAsyncComponent(
            () => import("@eg_ui/src/components/authentication/ViewPasswordField/ViewPasswordField.vue"),
        ),
    );

app.mount("#app-container");
